module.exports = __webpack_public_path__ + "img/viber_colored.43a4773a.svg";